<template>
  <div>
    <v-select
      class="select-fabric"
      :options="fabrics"
      :value="modelValue"
      :multiple="true"
      label="production_name"
      @input="setFabric"
      :closeOnSelect="false"
      :reduce="(option) => option.id"
      placeholder="Select Fabrics"
    />
  </div>
</template>

<script>
export default {
  props: ["value"],

  data() {
    return {
      fabrics: [],
      modelValue: [],
    };
  },

  watch: {
    value: function () {
      this.modelValue = this.value;
    },
  },

  mounted() {
    this.getFabrics();
    this.modelValue = this.value;
  },

  methods: {
    async getFabrics() {
      let res = await axios.get("/v2/fabrics?as_dropdown=1");
      this.fabrics = res.data.data.collection;
    },

    setFabric(value) {
      this.$emit("input", value);
    },
  },
};
</script>
